import Vue from "vue";
import { Player, Video, Youtube, Vimeo, DefaultUi } from "@vime/vue";
import "@vime/core/themes/default.css";
import "@vime/core/themes/light.css";
Vue.component("Player", Player);
Vue.component("Video", Video);
Vue.component("Youtube", Youtube);
Vue.component("Vimeo", Vimeo);
Vue.component("DefaultUi", DefaultUi);
